<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e883831" style="color: #82a339"><b>HUMMUS</b></p>
<p class="ext" id="d7e884331"><b><i>Middle Eastern dips, such as hummus, once seemed exotic, but now they’re familiar old friends. Tahini is readily available at health food stores and supermarkets.</i></b></p>
<p class="h4" id="d7e885631" style="color: #496210"><b>Prep: 15 minutes plus chilling</b></p>
<p class="ul" id="d7e886231">4 garlic cloves, peeled</p>
<p class="ul" id="d7e886531">1 large lemon</p>
<p class="ul" id="d7e886831">1 can (15 to 19 ounces) garbanzo beans, <br/> rinsed and drained</p>
<p class="ul" id="d7e887431">2 tablespoons tahini (sesame seed paste)</p>
<p class="ul" id="d7e887731">3 tablespoons olive oil</p>
<p class="ul" id="d7e888131">2 tablespoons water</p>
<p class="ul" id="d7e888431">½ teaspoon salt</p>
<p class="ul" id="d7e889331">⅛ teaspoon ground red pepper (cayenne)</p>
<p class="ul" id="d7e890331">½ teaspoon paprika</p>
<p class="ul" id="d7e891231">2 tablespoons chopped fresh cilantro (optional) <br/> pita bread wedges <br/> olives</p>
<p class="pub" id="d7e892431" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 1-quart saucepan, heat <i>2 cups water </i>to boiling over high heat. Add garlic and cook 3 minutes to blanch; drain.</p>
<p class="pub" id="d7e894231"><span style="color: #c15b49"><b>2.</b></span> From lemon, grate 1 teaspoon peel and squeeze 3 tablespoons juice. In food processor with knife blade attached, combine beans, tahini, garlic, lemon peel and juice, oil, water, salt, and ground red pepper. Puree until smooth. Transfer to platter; cover and refrigerate up to 4 hours. To serve, sprinkle with paprika and cilantro, if using. Serve with pita bread wedges and olives. Makes 2 cups.</p>
<p class="ntx" id="d7e897331">Each tablespoon: About 28 calories, 1g protein, 2g carbohydrate, 2g total fat (0g saturated), 0mg cholesterol, 54mg sodium.</p>
<div class="side"><p class="sidebarh3" id="d7e898331" style="color: #8A4117"><b>MEZE</b></p>
<p class="ser"><img alt="l.jpg" src="Images/l.jpg" style="max-width:100%;"/></p>
<p class="sidebartx1" id="d7e899031">Meze, little savory dishes to be nibbled before a meal or with drinks, are a tradition in Greece, Turkey, and the Middle East. Try any of the following with pita or French bread, along with feta cheese chunks, olives, radishes, sliced cucumbers, or tomato wedges: Roasted Red Pepper Dip, Tzatziki, or Hummus.</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c13_r1.vue?3e1caa93